export function cleanWebSocketUrl(wsUrl) {
  const url = new URL(wsUrl, globalThis.location?.origin || 'http://localhost')
  url.search = ''
  url.hash = ''
  return url.toString()
}

export function authApiBase(wsUrl, locationLike = globalThis.location) {
  if (locationLike?.origin && locationLike.origin !== 'null') return locationLike.origin
  const url = new URL(wsUrl)
  url.protocol = url.protocol === 'wss:' ? 'https:' : 'http:'
  url.pathname = ''
  url.search = ''
  url.hash = ''
  return url.origin
}

export async function bootstrapGuestSession({ wsUrl, name, avatar, fresh = false, storage, fetchImpl = globalThis.fetch, locationLike = globalThis.location, signal, onPhase = () => {} }) {
  if (typeof fetchImpl !== 'function') throw new Error('Session bootstrap requires fetch')
  const base = authApiBase(wsUrl, locationLike)
  const legacyToken = fresh ? null : storage?.get?.('authToken')
  const headers = { 'Content-Type': 'application/json' }
  if (legacyToken) headers.Authorization = `Bearer ${legacyToken}`
  onPhase('session', 'running')
  const sessionResponse = await fetchImpl(`${base}/api/auth/session`, {
    method: 'POST',
    credentials: 'include',
    headers,
    body: JSON.stringify({ fresh: fresh === true }), signal,
  })
  if (!sessionResponse.ok) {
    const error = new Error('Session bootstrap rejected')
    error.code = sessionResponse.status === 409 ? 'session_migration' : 'session_rejected'
    throw error
  }
  storage?.remove?.('authToken')
  onPhase('session', 'complete')

  onPhase('ticket', 'running')
  const ticketResponse = await fetchImpl(`${base}/api/auth/ws-ticket`, {
    method: 'POST',
    credentials: 'include',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ name: name || null, avatar: avatar || null }), signal,
  })
  if (!ticketResponse.ok) {
    const error = new Error('WebSocket ticket rejected')
    // Сервер закрывает мир до входа через провайдера — это не сбой, а
    // осмысленный отказ, и экран должен сказать про вход, а не про ошибку.
    error.code = ticketResponse.status === 403 ? 'login_required' : 'ticket_rejected'
    throw error
  }
  onPhase('ticket', 'complete')
  return cleanWebSocketUrl(wsUrl)
}

export async function logoutGuestSession({ fetchImpl = globalThis.fetch, locationLike = globalThis.location, signal } = {}) {
  if (typeof fetchImpl !== 'function' || !locationLike?.origin || locationLike.origin === 'null') throw new Error('Logout unavailable')
  const response = await fetchImpl(`${locationLike.origin}/api/auth/logout`, {
    method: 'POST', credentials: 'include', headers: { 'Content-Type': 'application/json' }, body: '{}', signal,
  })
  if (!response.ok) throw Object.assign(new Error('Logout rejected'), { code: response.status === 429 ? 'RATE_LIMITED' : 'LOGOUT_REJECTED' })
  return true
}
